const ROLE_IDS = {
  ADMIN_PLATFORM: 1,
  ADMIN_GCC: 2,
  SALES_MANAGER: 3, // GCC Sales
  PROJECT_MANAGER: 4, // GCC PM
  SUBCONTRACTOR: 5,
  CUSTOMER: 6,
  LEAD_PM: 7, // Lead PM,
  SALES_PM: 8, // SALES PM,
  TEAM_MEMBER: 9
} as const

type RoleKeys = (typeof ROLE_IDS)[keyof typeof ROLE_IDS]

// User.Role (backend IntegerChoices 1–9), ordered for role-scoped selectors.
// `nameKey` resolves via i18next; the fallback mirrors the backend choice label.
const USER_ROLE_OPTIONS: ReadonlyArray<{ id: RoleKeys; nameKey: string; fallback: string }> = [
  { id: ROLE_IDS.ADMIN_PLATFORM, nameKey: "roles.adminPlatform", fallback: "Platform Admin" },
  { id: ROLE_IDS.ADMIN_GCC, nameKey: "roles.adminGcc", fallback: "GCC Admin" },
  { id: ROLE_IDS.SALES_MANAGER, nameKey: "roles.salesManager", fallback: "Sales Manager" },
  { id: ROLE_IDS.PROJECT_MANAGER, nameKey: "roles.projectManager", fallback: "Project Manager" },
  { id: ROLE_IDS.SUBCONTRACTOR, nameKey: "roles.subcontractor", fallback: "Subcontractor" },
  { id: ROLE_IDS.CUSTOMER, nameKey: "roles.customer", fallback: "Customer" },
  { id: ROLE_IDS.LEAD_PM, nameKey: "roles.leadPm", fallback: "Lead PM" },
  { id: ROLE_IDS.SALES_PM, nameKey: "roles.salesPm", fallback: "Sales PM" },
  { id: ROLE_IDS.TEAM_MEMBER, nameKey: "roles.teamMember", fallback: "Team Member" }
]

// interface RoleEntity {
//   id: RoleKeys
//   label: string
//   color: string
//   backgroundColor: string
//   borderColor: string
// }

// const ROLE_MAP: Record<RoleKeys, RoleEntity> = {
//   [ROLE_IDS.ADMIN_PLATFORM]: {
//     id: ROLE_IDS.ADMIN_PLATFORM,
//     label: "Admin Platform",
//     color: "#004D40",
//     backgroundColor: "#CCFBF1",
//     borderColor: "#26A69A"
//   },
//   [ROLE_IDS.ADMIN_GCC]: {
//     id: ROLE_IDS.ADMIN_GCC,
//     label: "GCC Admin",
//     color: "#166534",
//     backgroundColor: "#CCFBF1",
//     borderColor: "#CCFBF1"
//   },
//   [ROLE_IDS.SALES_MANAGER]: {
//     id: ROLE_IDS.SALES_MANAGER,
//     label: "GCC Sales",
//     color: "#422cd2",
//     backgroundColor: "#deddef",
//     borderColor: "#deddef"
//   },
//   [ROLE_IDS.PROJECT_MANAGER]: {
//     id: ROLE_IDS.PROJECT_MANAGER,
//     label: "PM",
//     color: "#1E40AF",
//     backgroundColor: "#DBEAFE",
//     borderColor: "#DBEAFE"
//   },
//   [ROLE_IDS.SUBCONTRACTOR]: {
//     id: ROLE_IDS.SUBCONTRACTOR,
//     label: "Subcontractor",
//     color: "#BF360C",
//     backgroundColor: "#FBE9E7",
//     borderColor: "#FFAB91"
//   },
//   [ROLE_IDS.CUSTOMER]: {
//     id: ROLE_IDS.CUSTOMER,
//     label: "Customer",
//     color: "#1B5E20",
//     backgroundColor: "#E8F5E9",
//     borderColor: "#A5D6A7"
//   },
//   [ROLE_IDS.LEAD_PM]: {
//     id: ROLE_IDS.LEAD_PM,
//     label: "Lead PM",
//     color: "#4A148C",
//     backgroundColor: "#F3E5F5",
//     borderColor: "#CE93D8"
//   },
//   [ROLE_IDS.SALES_PM]: {
//     id: ROLE_IDS.LEAD_PM,
//     label: "Lead PM",
//     color: "#143a8c",
//     backgroundColor: "#e5e9f5",
//     borderColor: "#93a1d8"
//   }
// }

export { ROLE_IDS, USER_ROLE_OPTIONS, type RoleKeys }
